import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './assets/css/reset.css';
import './assets/css/fonts.css';
import './assets/css/style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
